module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table-row company-list-item list-item",
    on: {
      "click": function($event) {
        return _vm.toggleShowDkim($event)
      }
    }
  }, [_c('div', {
    staticClass: "table-col two-lines-col table-col-80 overflow-hidden"
  }, [_c('div', {
    staticClass: "name dark-slate-gray-color overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.company.name))]), _c('small', {
    staticClass: "email-domain text-gray-color overflow-ellipsis"
  }, [_vm._v(_vm._s(_vm.company.email_domain))])]), _c('div', {
    staticClass: "table-col table-col-50 table-col-multiple-lines-middle"
  }, [(_vm.company.isSparkpost()) ? _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "email-service",
    attrs: {
      "src": "/static/icons/third-part/sparkpost.png"
    }
  }), _c('div', {
    staticClass: "spacer-5"
  }), (_vm.company.email_domain_verified) ? _c('h6', {
    staticClass: "no-margin"
  }, [_c('div', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.verified')))])]) : _c('h6', {
    staticClass: "no-margin"
  }, [_c('div', {
    staticClass: "label label-warning"
  }, [_vm._v("Pendente")])])]) : _vm._e(), (_vm.company.isNylas()) ? _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "email-service",
    attrs: {
      "src": "/static/icons/third-part/nylas.svg",
      "title": "Nylas"
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.company.number_of_regular_users) + " / " + _vm._s(_vm.company.account_setting.id != null ? _vm.company.account_setting.max_number_of_regular_users : '-'))])]), _c('div', {
    staticClass: "table-col table-col-50"
  }, [_c('span', [_vm._v(_vm._s(_vm.company.number_of_monitoring_managers) + " / " + _vm._s(_vm.company.account_setting.id != null ? _vm.company.account_setting.max_number_of_monitoring_managers : '-'))])]), _c('div', {
    staticClass: "table-col table-col-30"
  }, [_c('span', {
    staticClass: "voip label",
    class: _vm.company.active ? "label-primary" : "label-default"
  }, [_vm._v(_vm._s(_vm.company.active ? _vm.$t('companies.label.activeCompany') : _vm.$t('companies.label.pausedCompany')))])]), _c('div', {
    staticClass: "table-col table-col-30"
  }, [_c('span', {
    staticClass: "voip label",
    class: _vm.company.isPlivo() || _vm.company.isTwilio() ? "label-primary" : "label-default"
  }, [_vm._v(_vm._s(_vm.company.isPlivo() || _vm.company.isTwilio() ? _vm.$t('general.label.active') : _vm.$t('general.label.inactive')))])]), _c('div', {
    staticClass: "table-col table-col-50"
  }, [(_vm.plivo_activated) ? _c('element', [_vm._v(_vm._s(_vm.company.plivo_setting.voip_monthly_plan.consumed_in_minutes()) + " / " + _vm._s(_vm.company.plivo_setting.voip_monthly_plan.max_duration_in_minutes()))]) : (_vm.twilio_activated) ? _c('element', [_vm._v(_vm._s(_vm.company.twilio_setting.voip_monthly_plan.consumed_in_minutes()) + " / " + _vm._s(_vm.company.twilio_setting.voip_monthly_plan.max_duration_in_minutes()))]) : _vm._e()]), _c('div', {
    staticClass: "table-col table-col-80",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "spacer-15 pull-right"
  }), _c('div', {
    staticClass: "spacer-15 pull-right"
  }), _c('div', {
    staticClass: "action pull-right clickable-element"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_vm._m(0), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.verify.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.verify')))])]), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editCompany.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))])])])])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_dkim && _vm.company.isSparkpost()),
      expression: "show_dkim && company.isSparkpost()"
    }],
    staticClass: "table-row dkim-attributes"
  }, [_c('div', {
    staticClass: "table-col"
  }, [_vm._v(_vm._s(_vm.company.dkim_selector))]), _c('div', {
    staticClass: "table-col"
  }, [_vm._v(_vm._s(_vm.company.dkim_value))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b1a7404!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/companies/list_item.vue
// module id = 1101
// module chunks = 1